"use client";
import Link from "next/link";
import {FaGithub, FaLinkedin, FaTwitter, FaInstagram} from "react-icons/fa";
import {FiArrowUp} from "react-icons/fi";

const socialLinks = [
  {href: "https://github.com/JuzzJoel", label: "GITHUB", icon: FaGithub},
  {href: "https://www.linkedin.com/in/joel-olajire-0a526a297/", label: "LINKEDIN", icon: FaLinkedin},
  {href: "https://x.com/JOOlajire", label: "TWITTER", icon: FaTwitter},
  {href: "https://www.instagram.com/joel_olajire/", label: "INSTAGRAM", icon: FaInstagram},
];

const navLinks = [
  {href: "/", label: "HOME"},
  {href: "/#about", label: "ABOUT"},
  {href: "/#projects", label: "PROJECTS"},
  {href: "/#skills", label: "SKILLS"},
  {href: "/#contact", label: "CONTACT"},
];

function scrollToTop() {
  window.scrollTo({top: 0, behavior: "smooth"});
}

export default function Footer() {
  return (
    <footer className="border-t-2 border-zinc-800 bg-zinc-950 py-12 font-mono text-xs">
      <div className="max-w-6xl mx-auto px-6">
        {/* Top row / Diagnostics */}
        <div className="grid gap-6 md:grid-cols-3 mb-10 pb-8 border-b border-zinc-800/80">
          <div>
            <div className="text-[10px] text-zinc-500 uppercase tracking-widest mb-2">[SYSTEM_READOUT]</div>
            <div className="space-y-1 text-zinc-400">
              <p>&gt; SECURE_SHELL: ENCRYPTED</p>
              <p>&gt; MEMORY_LOAD: NOMINAL</p>
              <p>&gt; LATENCY: 34MS</p>
            </div>
          </div>
          <div>
            <div className="text-[10px] text-zinc-500 uppercase tracking-widest mb-2">[CORE_TERMINAL]</div>
            <Link
              href="/"
              className="text-yellow-400 font-bold hover:underline font-display hover-glitch"
            >
              OLAJIRE_SYS_V1.0.0
            </Link>
            <p className="text-zinc-500 mt-1">Status: Active / Online</p>
          </div>
          <div className="flex flex-col items-start md:items-end justify-between">
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 px-3 py-2 border-2 border-zinc-800 bg-zinc-950 text-zinc-400 hover:text-yellow-400 hover:border-yellow-400 transition-none rounded-none cursor-pointer font-bold hover-glitch"
              aria-label="Scroll to top"
            >
              <FiArrowUp size={14} />
              RETURN_TO_TOP
            </button>
          </div>
        </div>

        {/* Links and Meta */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          {/* Navigation Directory */}
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-zinc-400 hover:text-yellow-400 hover:underline transition-colors font-bold hover-glitch"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Social Nodes */}
          <div className="flex items-center gap-4">
            {socialLinks.map(({href, label, icon: Icon}) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="flex items-center gap-1.5 text-zinc-400 hover:text-yellow-400 transition-colors font-bold hover-glitch"
              >
                <Icon size={14} />
                <span>{label}</span>
              </a>
            ))}
          </div>
        </div>

        {/* Legal divider */}
        <div className="mt-8 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row items-center justify-between gap-4 text-zinc-500 text-[10px]">
          <p>
            &copy; {new Date().getFullYear()} JOEL_OLAJIRE. ALL RIGHTS RESERVED.
          </p>
          <div className="flex gap-4">
            <Link href="/tos" className="hover:text-yellow-400 hover:underline">
              TERMS_OF_SERVICE
            </Link>
            <Link href="/privacy" className="hover:text-yellow-400 hover:underline">
              PRIVACY_POLICY
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
